import moment from 'moment';

export const parseDate = (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY');
